import { toursTrackType } from '@/masterdata/tours_tracktype'

export interface TourTypeOption {
  id: string
  name: string
}

export interface TourTypeOptionGroup {
  name: string
  options: TourTypeOption[]
}

export const tourTypeOptionGroups: TourTypeOptionGroup[] = Object.entries(toursTrackType).map(
  ([name, types]) => ({
    name,
    options: Object.values(types).map((type) => ({ id: type.garmin_id, name: type.name })),
  }),
)
